import base from 'components/base'
import mainMenu from 'components/mainMenu'
import $ from 'jquery'

class logo extends base
{
  elements = {
    container: null,
    siteContent: null
  }

  constructor(parentElement)
  {
    super()

    $(document).ready(() =>
    {
      this.elements.container = $('#logo').get(0)
      this.elements.siteContent = $('#site-content').get(0)

      this.bindEvents()
    })
  }

  bindEvents()
  {
    $(this.elements.container).find('a').on('click.'+ module.id, (event) =>
    {
      let href = $(event.currentTarget).attr('href')
      if(href)
      {
        let urlType = mainMenu.getUrlType(href)
        if(urlType === 'internal')
        {
          event.preventDefault()
          mainMenu.changePage(href, {
            element: this.elements.siteContent,
            errorsBefore: $(this.elements.siteContent).children().get(0)
          })
        }
      }
    })
  }
}

let instance = new logo()

export default instance



// WEBPACK FOOTER //
// ./vendor/response200/kustantajat/applications/publicFrontend/scripts/components/logo.js